module.exports = __webpack_public_path__ + "img/rickshaw-man-take-children-to-the-school-in-the-morning-in-new-delhi-d57twc.14b6d076.jpg";